import React from "react";
import PropTypes from "prop-types";
import { HeadingSize, Heading } from "@sunwing/wvi-components";
import { RichTextConnector } from "../RichTextConnector";

export function headerSizeAdapter(size) {
	let headingSize;
	switch (size) {
		case "Extra Large":
			headingSize = HeadingSize.xl;
			break;
		case "Large":
			headingSize = HeadingSize.lg;
			break;
		case "Medium":
			headingSize = HeadingSize.md;
			break;
		case "Small":
			headingSize = HeadingSize.sm;
			break;
		case "Extra Small":
			headingSize = HeadingSize.xs;
			break;
		case "Micro":
			headingSize = HeadingSize.micro;
			break;
		case "Eyebrow":
			headingSize = HeadingSize.eyebrow;
			break;
		default:
			break;
	}
	return headingSize;
}

const ParagraphConnector = ({ data }) => {
	let alignment;
	switch (data.alignment) {
		case "Right":
			alignment = "right";
			break;
		case "Center":
			alignment = "center";
			break;
		case "Left":
		default:
			alignment = "left";
			break;
	}
	return (
		<div style={{ textAlign: alignment }}>
			{data.heading && (
				<Heading Tag={data.headingAs} size={headerSizeAdapter(data.headingSize)} align={alignment}>
					{data.heading}
				</Heading>
			)}

			{data.subheading && (
				<Heading
					Tag={data.subheadingAs}
					size={headerSizeAdapter(data.subheadingSize)}
					align={alignment}>
					{data.subheading}
				</Heading>
			)}

			{data.content && <RichTextConnector data={data.content} />}
		</div>
	);
};

ParagraphConnector.propTypes = {
	data: PropTypes.shape({
		heading: PropTypes.string,
		headingAs: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "p"]),
		headingSize: PropTypes.oneOf([
			"Extra Large",
			"Large",
			"Medium",
			"Small",
			"Extra Small",
			"Micro",
			"Eyebrow",
		]),
		subheading: PropTypes.string,
		subheadingAs: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "p"]),
		subheadingSize: PropTypes.oneOf([
			"Extra Large",
			"Large",
			"Medium",
			"Small",
			"Extra Small",
			"Micro",
			"Eyebrow",
		]),
		alignment: PropTypes.oneOf(["Left", "Center", "Right"]),
		content: PropTypes.shape({
			raw: PropTypes.string.isRequired,
			references: PropTypes.array,
		}),
	}).isRequired,
};

export { ParagraphConnector };
